/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, computed, openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, normalizeClass, normalizeStyle, renderSlot, vShow } from 'vue';
import { preventDefault } from '../shared/dom.js';
import config from '../config.js';
import props from './props.js';
import 'lodash/isFunction';
import 'lodash/isString';

var prefix = config.prefix;
var name = "".concat(prefix, "-overlay");
var script = defineComponent({
  name: name,
  props: props,
  setup: function setup(props2) {
    var classes = computed(function () {
      var _ref;
      return _ref = {}, _defineProperty(_ref, "".concat(name), true), _defineProperty(_ref, "".concat(name, "--active"), props2.visible), _ref;
    });
    var rootStyles = computed(function () {
      var arr = [];
      if (props2.customStyle) {
        arr.push(props2.customStyle);
      }
      if (props2.zIndex) {
        arr.push("z-index: ".concat(props2.zIndex));
      }
      if (props2.duration) {
        arr.push("transition-duration: ".concat(props2.duration, "ms"));
      }
      if (props2.backgroundColor) {
        arr.push("background-color: ".concat(props2.backgroundColor));
      }
      return arr.join("; ");
    });
    var handleTouchMove = function handleTouchMove(e) {
      if (props2.preventScrollThrough) {
        preventDefault(e, true);
      }
    };
    var handleClick = function handleClick(e) {
      var _props2$onClick;
      (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, {
        e: e
      });
    };
    return {
      name: name,
      classes: classes,
      rootStyles: rootStyles,
      handleClick: handleClick,
      handleTouchMove: handleTouchMove
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: _ctx.name
  }, {
    default: withCtx(function () {
      return [withDirectives(createElementVNode("div", {
        class: normalizeClass(_ctx.classes),
        style: normalizeStyle(_ctx.rootStyles),
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.handleClick && _ctx.handleClick.apply(_ctx, arguments);
        }),
        onTouchmove: _cache[1] || (_cache[1] = function () {
          return _ctx.handleTouchMove && _ctx.handleTouchMove.apply(_ctx, arguments);
        })
      }, [renderSlot(_ctx.$slots, "default")], 38), [[vShow, _ctx.visible]])];
    }),
    _: 3
  }, 8, ["name"]);
}

script.render = render;

export { script as default };
//# sourceMappingURL=overlay.js.map
